/* Local photographic personalization. The source photograph is never regenerated.
 * Names are drawn into a transparent texture, mapped into a calibrated quadrilateral,
 * then composited over the existing leather. Coordinates are illustrative, not a proof.
 * No names in analytics, localStorage, query strings, or image-generation requests.
 */
function createScribenPersonalizer(root, settings, notify) {
  'use strict';
  const $ = s => root.querySelector(s);
  const canvas = $('#se-name-canvas');
  const sourceEl = $('[data-personalization-source]');
  const message = $('[data-preview-message]');
  const stateLabel = $('[data-preview-state]');
  const saveButton = $('[data-save-personalization]');
  const defaultCal = {
    id:'sleeve-loop-v1',
    quad:[[145/318,203/684],[242/318,221/684],[237/318,235/684],[140/318,217/684]],
    detailCrop:[83/318,87/684,224/318,168/684],
    finish:'Blind deboss · Black leather', placement:'Leather retaining loop'
  };
  if(typeof settings==='string'){try{settings=JSON.parse(settings);}catch(_){settings=null;}}
  const calibration = settings && typeof settings === 'object' ? settings : defaultCal;
  const validQuad = q => Array.isArray(q) && q.length===4 && q.every(p=>Array.isArray(p)&&p.length===2&&p.every(n=>typeof n==='number'&&Number.isFinite(n)&&n>=0&&n<=1));
  const cal = Object.assign({},defaultCal,calibration);
  if(!validQuad(cal.quad))cal.quad=defaultCal.quad;
  if(!Array.isArray(cal.detailCrop)||cal.detailCrop.length!==4||!cal.detailCrop.every(n=>Number.isFinite(n)&&n>=0&&n<=1)||cal.detailCrop[2]<=0||cal.detailCrop[3]<=0||cal.detailCrop[0]+cal.detailCrop[2]>1||cal.detailCrop[1]+cal.detailCrop[3]>1)cal.detailCrop=defaultCal.detailCrop;
  const context = canvas && canvas.getContext && canvas.getContext('2d');
  let loaded=false, name='', plain=false, valid=true, view='detail', frame=0;
  const photo = new Image();
  const scene = document.createElement('canvas');
  scene.width=954;scene.height=2052;
  const sc = scene.getContext('2d');
  let renderName = null;
  const fontFamily = 'Georgia, "Times New Roman", serif';

  function updateStatus() {
    stateLabel.textContent=plain ? 'THE ORIGINAL · WITHOUT A NAME' : !valid ? 'CHECK YOUR LETTERING BELOW' : name ? 'YOUR NAME · BLIND DEBOSS PREVIEW' : 'EXAMPLE LETTERING · TYPE TO MAKE IT YOURS';
    canvas.setAttribute('aria-label', plain ? 'Original black leather sleeve without personalized lettering' : name&&valid ? `Illustrative blind-debossed name on the leather loop: ${name}` : 'Example lettering on a black leather sleeve. Enter your name below to personalize it.');
    canvas.dataset.renderedName=plain ? '' : valid ? name : '';
    saveButton.disabled=!loaded||!valid||(!plain&&!name);
  }
  if(!context || !sc || !sourceEl) {
    if(message)message.textContent='The photo preview is unavailable in this browser. Your chosen name will still appear in the order summary.';
    return {set(){},capture(){return null;},ready:false,calibration:cal};
  }

  // Draw each strip of the text texture into the real perspective of the loop.
  // A gently bowed baseline follows the curvature of this particular photo.
  function warp(texture) {
    const q=cal.quad.map(p=>({x:p[0]*scene.width,y:p[1]*scene.height}));
    const lerp=(a,b,t)=>({x:a.x+(b.x-a.x)*t,y:a.y+(b.y-a.y)*t});
    const count=48;
    for(let i=0;i<count;i++) {
      const t0=i/count,t1=(i+1)/count;
      const tl=lerp(q[0],q[1],t0),tr=lerp(q[0],q[1],t1);
      const bl=lerp(q[3],q[2],t0),br=lerp(q[3],q[2],t1);
      const bend0=-Math.sin(Math.PI*t0)*1.8,bend1=-Math.sin(Math.PI*t1)*1.8;
      tl.y+=bend0;bl.y+=bend0;tr.y+=bend1;br.y+=bend1;
      const sx=texture.width*t0,sw=texture.width/count;
      sc.save();sc.beginPath();sc.moveTo(tl.x,tl.y);sc.lineTo(tr.x+.35,tr.y);sc.lineTo(br.x+.35,br.y);sc.lineTo(bl.x,bl.y);sc.closePath();sc.clip();
      sc.transform((tr.x-tl.x)/sw,(tr.y-tl.y)/sw,(bl.x-tl.x)/texture.height,(bl.y-tl.y)/texture.height,tl.x,tl.y);
      sc.drawImage(texture,sx,0,sw+.12,texture.height,0,0,sw+.12,texture.height);
      sc.restore();
    }
  }
  function compose(text) {
    sc.clearRect(0,0,scene.width,scene.height);
    sc.imageSmoothingEnabled=true;sc.imageSmoothingQuality='high';
    sc.drawImage(photo,0,0,scene.width,scene.height);
    if(!text)return;
    const texture=document.createElement('canvas');texture.width=1440;texture.height=200;
    const tc=texture.getContext('2d');
    let size=158;
    tc.font=`500 ${size}px ${fontFamily}`;
    while(tc.measureText(text).width>texture.width-125 && size>36){size-=1;tc.font=`500 ${size}px ${fontFamily}`;}
    tc.textAlign='center';tc.textBaseline='middle';
    const x=texture.width/2,y=texture.height/2+size*.035;
    // A recessed face, shadow on the upper edge, and restrained warm lower rim.
    // No gold-foil option is advertised: this edition is black-on-black debossing.
    tc.fillStyle='rgba(228,218,196,.58)';tc.fillText(text,x+1.8,y+3.0);
    tc.shadowColor='rgba(0,0,0,.55)';tc.shadowBlur=2;tc.shadowOffsetX=-1;tc.shadowOffsetY=-1.5;
    tc.fillStyle='rgba(5,5,4,.9)';tc.fillText(text,x,y);
    tc.shadowColor='transparent';tc.fillStyle='rgba(76,67,53,.2)';tc.fillText(text,x+.4,y+.5);
    warp(texture);
  }
  function paint(target, type) {
    const c=target.getContext('2d');c.clearRect(0,0,target.width,target.height);
    c.imageSmoothingEnabled=true;c.imageSmoothingQuality='high';
    c.fillStyle='#181814';c.fillRect(0,0,target.width,target.height);
    if(type==='sleeve'){
      const scale=Math.min(target.width/scene.width,target.height/scene.height);
      const w=scene.width*scale,h=scene.height*scale;
      c.drawImage(scene,(target.width-w)/2,(target.height-h)/2,w,h);
    }else{
      const [x,y,w,h]=cal.detailCrop;
      c.drawImage(scene,x*scene.width,y*scene.height,w*scene.width,h*scene.height,0,0,target.width,target.height);
    }
  }
  function render() {
    frame=0;
    if(!loaded)return;
    const text=plain||!valid ? '' : name||'Your Name';
    if(renderName!==text){compose(text);renderName=text;}
    paint(canvas,view);updateStatus();
    canvas.dataset.previewReady='true';
  }
  function queue(){if(!frame)frame=requestAnimationFrame(render);}
  function capture(type='detail', width=1120, suppliedName) {
    if(!loaded)return null;
    const output=document.createElement('canvas');output.width=width;output.height=Math.round(width*.75);
    const restore=renderName;
    if(suppliedName!==undefined)compose(suppliedName);
    paint(output,type);
    if(suppliedName!==undefined){compose(restore||'');}
    try{return output.toDataURL('image/jpeg',.94);}catch(_){return null;}
  }
  photo.onload=()=>{loaded=true;renderName=null;message.textContent='';render();};
  photo.onerror=()=>{message.textContent='The preview image could not load. Your name is still shown below; please check your connection or contact Scriben.';canvas.dataset.previewReady='error';};
  const source=sourceEl.currentSrc||sourceEl.src;
  if(/^https?:/.test(source))photo.crossOrigin='anonymous';
  photo.src=source;
  if(document.fonts&&document.fonts.ready)document.fonts.ready.then(()=>{renderName=null;queue();});
  root.querySelectorAll('[data-preview-view]').forEach(button=>button.addEventListener('click',()=>{
    view=button.dataset.previewView==='sleeve'?'sleeve':'detail';
    root.querySelectorAll('[data-preview-view]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));
    queue();
  }));
  saveButton.addEventListener('click',()=>{
    if(!loaded||!valid||(!plain&&!name))return;
    render();
    const result=document.createElement('canvas');result.width=1200;result.height=1230;
    const c=result.getContext('2d');c.fillStyle='#faf8f4';c.fillRect(0,0,1200,1230);
    c.fillStyle='#28251f';c.font=`52px ${fontFamily}`;c.fillText('Scriben',58,80);
    c.font='15px Arial, sans-serif';c.fillStyle='#877451';c.fillText('EXECUTIVE EDITION  /  PERSONALIZATION PREVIEW',60,119);
    const photograph=document.createElement('canvas');photograph.width=1080;photograph.height=810;paint(photograph,'detail');c.drawImage(photograph,60,161);
    const detail=plain?'Without personalization':name;
    let size=42;c.font=`${size}px ${fontFamily}`;
    while(c.measureText(detail).width>1080&&size>20){size--;c.font=`${size}px ${fontFamily}`;}
    c.textAlign='center';c.fillStyle='#30291f';c.fillText(detail,600,1035);
    c.fillStyle='#897d6a';c.font='17px Arial, sans-serif';c.fillText('Blind deboss · Black leather',600,1075);
    c.font='14px Arial, sans-serif';c.fillText('Visual preview only. Final type, size, depth and placement may vary.',600,1140);
    c.fillText('This image is not a production proof or an order confirmation.',600,1168);
    try{
      result.toBlob(blob=>{
        if(!blob){message.textContent='The image could not be saved. You can still use the live preview.';return;}
        const url=URL.createObjectURL(blob),a=document.createElement('a');a.href=url;
        const safe=(plain?'plain':name).normalize('NFKD').replace(/[^a-zA-Z0-9 -]/g,'').trim().replace(/\s+/g,'-').slice(0,48)||'personalized';
        a.download=`Scriben-${safe}-preview.png`;document.body.appendChild(a);a.click();a.remove();
        setTimeout(()=>URL.revokeObjectURL(url),60000);
        message.textContent='Your preview is ready to save. No order has been placed.';
        if(notify)notify('Personalization preview image created.');
      },'image/png');
    }catch(_){message.textContent='Saving is unavailable for this image source. The live preview and your order details still work.';}
  });
  return {
    set(value,withoutName,isValid=true){name=String(value||'').trim();plain=!!withoutName;valid=isValid;renderName=null;updateStatus();queue();},
    capture,calibration:cal,
    get ready(){return loaded;}
  };
}


/* Scriben Executive — the editorial half of the page.
 *
 * The buy column above this is the theme's: its gallery, its variant picker,
 * its add-to-cart. The engraving field is sbn-exec-buy.liquid, which calls
 * createScribenPersonalizer above. So there is no cart, no price and no form
 * in here — only the tabbed software demonstration, the sticky buy bar and
 * anchor scrolling.
 *
 * No analytics, secret keys, payment capture, external libraries or cookies.
 */
(() => {
  'use strict';
  function mount(root) {
    if (!root || root.dataset.initialized === 'true') return;
    root.dataset.initialized = 'true';
    const $ = (s, scope = root) => scope.querySelector(s);
    const $$ = (s, scope = root) => Array.from(scope.querySelectorAll(s));
    const announce = msg => { const el = $('[data-announcement]'); if (el) el.textContent = msg; };

    // Illustrative UI, never actual recorded data or an operational AI client.
    const phone = $('[data-phone-content]');
    if (phone) {
      const captureHTML = phone.innerHTML;
    const steps = {
        capture:{kicker:'01 / CAPTURE',title:'A simple press.<br>A fuller conversation.',copy:'Start recording with a press of the clip. Keep your attention on the person across the table, not on a screen.',benefit:'One-press recording. A real, everyday pen.',floating:'Be here.<br>The details can follow.',html:captureHTML},
        understand:{kicker:'02 / UNDERSTAND',title:'From a conversation<br>to a clear next step.',copy:'Review a structured summary, important decisions and action items without reconstructing the meeting from scattered notes.',benefit:'The key points, organized for your review.',floating:'The meeting ends.<br>Clarity stays.',html:'<p class="se-app-kicker">CLIENT CONVERSATION</p><h4>Quarterly<br>review</h4><p class="se-app-meta">Today · 28 min</p><div class="se-phone-tabbar"><span>Transcript</span><b>Summary</b><span>To do</span></div><p class="se-app-summary">The client would like to move ahead with a revised scope and a clearer timeline for the next phase.</p><span class="se-app-label">NEXT STEPS</span><div class="se-app-task">Prepare the revised scope</div><div class="se-app-task">Share the engagement letter</div><div class="se-app-task">Confirm next week’s meeting</div>'},
        remember:{kicker:'03 / REMEMBER',title:'Ask the conversation.<br>Not your memory.',copy:'Return to a client detail, a decision or a commitment. Ask Scriben for an answer grounded in the conversation it came from.',benefit:'Retrieve the detail. Return to its context.',floating:'The answer.<br>In its context.',html:'<p class="se-app-kicker">ASK SCRIBEN</p><h4>A detail<br>worth keeping.</h4><div class="se-chat-question">What did we agree to send before the next meeting?</div><div class="se-chat-answer">The revised scope and the engagement letter, so the client can review both in advance.<small>FROM · QUARTERLY REVIEW<br>Conversation reference · 18:42</small></div><div class="se-app-note"><span>YOUR CONVERSATIONS, CONNECTED</span><p>Bring the context with you.</p></div>'},
        follow:{kicker:'04 / FOLLOW THROUGH',title:'Thoughtful follow-ups.<br>Already taking shape.',copy:'Prepare a follow-up email or the next action from what was discussed. Review the details before anything is sent.',benefit:'Your draft. Your review. Your approval.',floating:'Ready to review.<br>Still your voice.',html:'<p class="se-app-kicker">THE NEXT CONVERSATION</p><h4>Follow through.</h4><p class="se-draft-label">EMAIL DRAFT · NOT SENT</p><div class="se-draft"><strong>Subject: Next steps from our review</strong><p>Thank you for the conversation today.</p><p>I’ll share the revised scope and engagement letter ahead of our next meeting.</p><p>Please let me know whether Thursday works for you.</p><div class="se-draft-status">Prepared from your conversation</div></div><div class="se-review-label">Awaiting your review</div>'}
      };
      steps.capture.html = captureHTML;
      const tabs = $$('[data-step]');
      const selectStep = (index, focus = false) => {
        const button = tabs[index];
        if (!button) return;
        const s = steps[button.dataset.step];
        tabs.forEach(b => { const on = b === button; b.setAttribute('aria-selected', String(on)); b.tabIndex = on ? 0 : -1; });
        $('#se-panel').setAttribute('aria-labelledby', button.id);
        $('[data-step-kicker]').textContent = s.kicker;
        $('[data-step-title]').innerHTML = s.title;
        $('[data-step-copy]').textContent = s.copy;
        $('[data-step-benefit]').textContent = s.benefit;
        $('[data-floating-copy]').innerHTML = s.floating;
        phone.innerHTML = s.html;
        if (focus) button.focus();
      };
      tabs.forEach((b, i) => {
        b.addEventListener('click', () => selectStep(i));
        b.addEventListener('keydown', e => {
          let next = null;
          if (e.key === 'ArrowRight') next = (i + 1) % tabs.length;
          if (e.key === 'ArrowLeft') next = (i - 1 + tabs.length) % tabs.length;
          if (e.key === 'Home') next = 0;
          if (e.key === 'End') next = tabs.length - 1;
          if (next !== null) { e.preventDefault(); selectStep(next, true); }
        });
      });
    }

    // NO STICKY BAR HERE. This page had its own, and it competed with the
    // theme's -- two bars, two prices, two calls to action. The theme's is the
    // one Agam wants throughout ("BUY NOW for $249: SALE ENDS SOON!"), it is
    // styled by pdp-pen-page.liquid, and it is the same bar the pen and both
    // bundles show. So this file no longer renders, measures or scrolls one.

    // Anchors work without JavaScript; this only smooths them. #sbn-x-buy is
    // the colour row at the top of the buy column, so a buy tap lands on the
    // real purchase controls. It focuses the target only when it is an input,
    // which a fieldset is not -- so this is a scroll and nothing more.
    $$('a[href^="#"]').forEach(a => a.addEventListener('click', e => {
      const target = document.getElementById(a.getAttribute('href').slice(1));
      if (!target) return;
      e.preventDefault();
      const smooth = !matchMedia('(prefers-reduced-motion: reduce)').matches;
      target.scrollIntoView({ behavior: smooth ? 'smooth' : 'auto', block: 'center' });
      if (target.tagName === 'INPUT' && !target.disabled) {
        setTimeout(() => target.focus({ preventScroll: true }), smooth ? 420 : 0);
        announce('Engraving field focused.');
      }
    }));
  }
  function start() { mount(document.getElementById('scriben-executive')); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
  document.addEventListener('shopify:section:load', start);
})();

